import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { OverrideService } from '../../../../@shelter/utils/override.service';
import { UserService } from '../../../core/user/user.service';

export type ControlEntityData = {
  isEdit: boolean;
  route: string;
  name: {
    single:string,
    plural:string
  };
  onSave: () => void;
  form: FormGroup
}
@Component({
  selector: 'old-control-design',
  templateUrl: './control-design.component.html',
  styleUrls: ['./control-design.component.scss']
})
export class ControlDesignComponent implements OnInit {
  @Input() entityData: ControlEntityData;

  constructor(public override: OverrideService,public translate: TranslocoService,public userService: UserService) { }

  ngOnInit(): void {
  }

}
